





















import { defineComponent }   from '@vue/composition-api';
import ElDatePicker          from 'element-ui/lib/date-picker';
import { DatePickerOptions } from 'element-ui/types/date-picker';

export default defineComponent({
  name: 'cDatePicker',
  components: {
    ElDatePicker,
  },
  setup() {
    const pickerOptions: DatePickerOptions = {
      firstDayOfWeek: 1,
    };

    return {
      pickerOptions,
    };
  },
});
